/**
 * Interactive Reading validator — EAA-1755.
 * Inline field validation surfaced under the matching editor inputs.
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { InteractiveReadingData } from './schema';
import { MAX_READING_TEXT_LENGTH } from './schema';

export const interactiveReadingValidator: ContentValidator<InteractiveReadingData> = {
    validate(data: InteractiveReadingData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        const text = (data?.text ?? '').trim();
        if (!text) {
            errors.push({ field: 'text', message: 'Reading text is required.' });
        } else if (text.length > MAX_READING_TEXT_LENGTH) {
            errors.push({
                field: 'text',
                message: `Reading text must be at most ${MAX_READING_TEXT_LENGTH} characters.`,
            });
        }

        return { isValid: errors.length === 0, errors };
    },
};
